







































import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';
import GeoMapLoader from '@/components/organisms/GeoMap/GeoMapLoader.vue';
import GeoMapMarkerClustererList from '@/components/organisms/GeoMap/GeoMapMarkerClustererList.vue';
import { mapSettings } from '@/components/organisms/GeoMap/constants/mapSettings';
import PerformanceWidget from '@/components/organisms/Performance/PerformanceWidget/index.vue';
import PerformanceWidgetMapListingDetail
  from '@/components/organisms/Performance/PerformanceWidget/PerformanceWidgetMap/PerformanceWidgetMapListingDetail/index.vue';
import PerformanceActionTypes from '@/modules/performance/PerformanceActionTypes';
import { Action } from 'vuex-class';
import GeoMapLineList from '@/components/organisms/GeoMap/GeoMapLineList.vue';
import MarketWidgetMapListingDetail
  from '@/components/organisms/Performance/PerformanceWidget/PerformanceWidgetMap/MarketWidgetMapListingDetail/index.vue';

@Component({
  name: 'PerformanceWidgetRegionMap',
  components: {
    PerformanceWidget,
    GeoMapLoader,
    GeoMapMarkerClustererList,
    PerformanceWidgetMapListingDetail,
    GeoMapLineList,
    MarketWidgetMapListingDetail,
  },
})
export default class PerformanceWidgetRegionMap extends Vue {
  @Prop() protected loading!: any;

  @Prop() protected listings!: any;

  @Prop() protected selectedListingId!: any;

  @Prop() protected currency!: any;

  @Prop() protected borders!: any;

  @Prop() protected polygonType!: any;

  @Action(PerformanceActionTypes.SELECT_LISTING_FROM_REGION_MAP, { namespace: 'performance' })
  protected dispatchSelectListing!: any;

  protected markers: any = {};

  protected listingDetail: any = null;

  protected markersNeedUpdate: any = [];

  protected mapConfig: any = {
    ...mapSettings,
    zoom: 14,
    fullscreenControl: false,
  };

  protected getSelectedIcon = () => ({
    path: 'M6.95191 0C3.11865 0 0 3.11865 0 6.9519C0 11.7699 6.95874 20 6.95874 20C6.95874 20 13.9038 11.533 13.9038 6.9519C13.9038 3.11865 10.7853 0 6.95191 0ZM9.04944 8.98743C8.47107 9.56567 7.71155 9.85486 6.95191 9.85486C6.19238 9.85486 5.43262 9.56567 4.85449 8.98743C3.69788 7.83093 3.69788 5.9491 4.85449 4.79248C5.41455 4.23218 6.15955 3.92358 6.95191 3.92358C7.74426 3.92358 8.48914 4.2323 9.04944 4.79248C10.2061 5.9491 10.2061 7.83093 9.04944 8.98743Z',
    strokeOpacity: 1,
    strokeWeight: 2,
    fillOpacity: 1,
    strokeColor: '#FCFCFC',
    fillColor: '#4077F6',
    scale: 2.5,
    anchor: [2.75, 15],
  });

  protected getMarkerIcon = () => `${process.env.VUE_APP_URL_PREFIX ? process.env.VUE_APP_URL_PREFIX : '/'}img/black_marker.svg`;

  protected getMarker(item: any) {
    const icon = item.platformListingId === this.selectedListingId
      ? this.getSelectedIcon()
      : this.getMarkerIcon();
    return {
      data: {
        selected: item.platformListingId === this.selectedListingId,
        id: item.platformListingId,
        position: { lat: item.latitude, lng: item.longitude },
      },
      name: item.title,
      icon,
    };
  }

  protected getMarkers() {
    if (!this.listings) {
      return {};
    }
    const result: any = {};

    Object.keys(this.listings).forEach((key: any) => {
      const item = this.listings[key];
      result[key] = this.getMarker(item);
    });
    return result;
  }

  @Watch('listings', { deep: true, immediate: true })
  protected onChangeListings() {
    this.markers = this.getMarkers();
  }

  @Watch('selectedListingId', { deep: true })
  protected onChangeSelectedListingId(next: any, prev: any) {
    if (this.listings) {
      const listingIds: any = [next, prev];
      this.markersNeedUpdate = [];
      listingIds.forEach((value: any) => {
        if (value) {
          const marker: any = this.getMarker(this.listings[value]);
          this.markersNeedUpdate.push(marker);
          this.$set(this.markers, value, marker);
        } else {
          this.markersNeedUpdate.push(null);
        }
      });
      this.listingDetail = this.listings[this.selectedListingId];
    }
  }

  protected onSelectMarker(marker: any) {
    this.dispatchSelectListing(marker.data.id);
  }

  protected onCloseListingDetail() {
    this.dispatchSelectListing(null);
    this.listingDetail = null;
  }
}
